import { useMediaQuery } from 'react-responsive'

export const useIsMobile = (): boolean =>
  useMediaQuery({ minWidth: 0, maxWidth: 767 })
export const useLaptop = (): boolean =>
  useMediaQuery({ minWidth: 1024, maxWidth: 1439 })
export const useDesktop = (): boolean =>
  useMediaQuery({ minWidth: 1440, maxWidth: 2559 })
